// 'success' 'error' 'warning' 'info'
export default {
  GET_SUB_SERVICE_SELECTED_LIST: 'get_sub_service_selected_list',
  CLEAR_SUB_SERVICE_SELECTED_LIST: 'clear_sub_service_selected_list',
  ADD_DATA_RES_CHECK_PRICE: 'add_data_res_check_price',
  UPDATE_DATA_RES_CHECK_PRICE: 'update_data_res_check_price',
  DELETE_DATA_RES_CHECK_PRICE: 'delete_data_res_check_price',
};
